import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { testRoasterNotification } from '../services/roasterNotificationService';

const TestRoasterNotification = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const { currentUser } = useAuth();

  const handleTestNotification = async () => {
    if (!currentUser) {
      setError('You must be logged in to test notifications');
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await testRoasterNotification();
      setResult(response);
      console.log('Roaster notification test successful:', response);
    } catch (err) {
      console.error('Roaster notification test failed:', err);
      setError(err.message || 'Test failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px', color: '#2d3748' }}>
        Test Roaster WhatsApp Notification
      </h2>
      
      <div style={{ marginBottom: '20px', padding: '16px', backgroundColor: '#f7fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
        <h3 style={{ margin: '0 0 8px 0', color: '#4a5568', fontSize: '16px' }}>Setup Instructions:</h3>
        <ol style={{ margin: '0', paddingLeft: '20px', color: '#718096', fontSize: '14px', lineHeight: '1.5' }}>
          <li>Add CallMeBot number to roaster's WhatsApp contacts</li>
          <li>Send "I allow callmebot to send me messages" to get API key</li>
          <li>Update the roaster phone number and API key in the notification service</li>
          <li>Test the integration using this button</li>
        </ol>
      </div>

      <button
        onClick={handleTestNotification}
        disabled={loading || !currentUser}
        style={{
          padding: '12px 24px',
          borderRadius: '8px',
          border: 'none',
          fontSize: '16px',
          fontWeight: '600',
          cursor: loading || !currentUser ? 'not-allowed' : 'pointer',
          backgroundColor: loading || !currentUser ? '#cbd5e0' : '#8b5a3c',
          color: '#fff',
          transition: 'all 0.2s ease'
        }}
      >
        {loading ? 'Sending Test...' : 'Send Test Notification to Roaster'}
      </button>
      
      {error && (
        <div style={{
          marginTop: '16px',
          padding: '16px',
          backgroundColor: '#fed7d7',
          border: '1px solid #feb2b2',
          color: '#c53030',
          borderRadius: '8px',
          fontSize: '14px'
        }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      
      {result && (
        <div style={{
          marginTop: '16px',
          padding: '16px',
          backgroundColor: '#c6f6d5',
          border: '1px solid #9ae6b4',
          color: '#276749',
          borderRadius: '8px',
          fontSize: '14px'
        }}>
          <p style={{ margin: '0 0 8px 0' }}><strong>Success!</strong> {result.message}</p>
          <pre style={{
            margin: '8px 0 0 0',
            padding: '8px',
            backgroundColor: '#fff',
            borderRadius: '4px',
            fontSize: '12px',
            overflow: 'auto'
          }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}

      <div style={{ marginTop: '24px', padding: '16px', backgroundColor: '#d1fae5', border: '1px solid #9ae6b4', borderRadius: '8px' }}>
        <h3 style={{ margin: '0 0 8px 0', color: '#065f46', fontSize: '16px' }}>✅ Ready to Use</h3>
        <p style={{ margin: '0', color: '#065f46', fontSize: '14px', lineHeight: '1.5' }}>
          The roaster notification system is configured with your existing CallMeBot credentials 
          and deployed as a Cloud Function. Test it above or submit a real beans request to see it in action!
        </p>
      </div>
    </div>
  );
};

export default TestRoasterNotification;